import { render, staticRenderFns } from "./batches.vue?vue&type=template&id=67f1660d&scoped=true&"
import script from "./batches.vue?vue&type=script&lang=js&"
export * from "./batches.vue?vue&type=script&lang=js&"
import style0 from "./batches.vue?vue&type=style&index=0&id=67f1660d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f1660d",
  null
  
)

export default component.exports